import { render, staticRenderFns } from "./UnAuthenticatedLayout.vue?vue&type=template&id=1241ff90"
import script from "./UnAuthenticatedLayout.vue?vue&type=script&lang=js"
export * from "./UnAuthenticatedLayout.vue?vue&type=script&lang=js"
import style0 from "./UnAuthenticatedLayout.vue?vue&type=style&index=0&id=1241ff90&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports